<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="ID：" prop="id" class="auto-width">
                <el-input v-model="filterForm.id" class="w120" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="公司代理名称：" prop="name" class="auto-width">
                <el-input v-model="filterForm.name" class="w120" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-select v-model="filterForm.status" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="启用" value="0"></el-option>
                  <el-option label="停用" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务代理等级：" prop="serviceLevelId">
                <el-select v-model="filterForm.serviceLevelId" placeholder="请选择" :loading="serviceLevelLoading">
                  <el-option v-for="(row, rowIndex) in serviceLevelOptions" :label="row.name" :value="row.id"
                    :key="rowIndex"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品代理等级：" prop="productLevelId">
                <el-select v-model="filterForm.productLevelId" placeholder="请选择" :loading="goodsLevelLoading">
                  <el-option v-for="(row, rowIndex) in goodsLevelOptions" :label="row.name" :value="row.id"
                    :key="rowIndex"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <div class="btn-list margin-top-20">
          <el-button type="primary" @click="handleAdd">添加公司代理</el-button>
          <el-button type="primary" @click="pageNavigateToServiceLevel">服务分佣设置</el-button>
          <el-button type="primary" @click="pageNavigateToGoodsLevel">商品分佣设置</el-button>
        </div>

        <!-- table -->
        <div class="table-region last-text-align-right" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable">
            <el-table-column label="ID" width="70">
              <template slot-scope="scope">
                <p>{{ scope.row.id }}</p>
              </template>
            </el-table-column>
            <el-table-column label="公司代理名称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="服务代理等级">
              <template slot-scope="scope">
                <p>{{ scope.row.serviceLevel }}</p>
              </template>
            </el-table-column>
            <el-table-column label="商品代理等级">
              <template slot-scope="scope">
                <p>{{ scope.row.productLevel }}</p>
              </template>
            </el-table-column>
            <el-table-column label="公司联系人">
              <template slot-scope="scope">
                <p>{{ scope.row.contact }}</p>
              </template>
            </el-table-column>
            <el-table-column label="联系人手机号">
              <template slot-scope="scope">
                <p>{{ scope.row.mobile }}</p>
              </template>
            </el-table-column>
            <el-table-column label="员工总数" sortable sort-by="employeeNum">
              <template slot-scope="scope">
                <p>{{ scope.row.employeeNum }}</p>
              </template>
            </el-table-column>
            <el-table-column label="子代理(公司)总数" sortable sort-by="childCompanyNum">
              <template slot-scope="scope">
                <p>{{ scope.row.childCompanyNum }}</p>
              </template>
            </el-table-column>
            <el-table-column label="子代理(个人)总数" sortable sort-by="childAgentNum">
              <template slot-scope="scope">
                <p>{{ scope.row.childAgentNum }}</p>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" sortable sort-by="createDate">
              <template slot-scope="scope">
                <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120">
              <template slot-scope="scope">
                <el-popover placement="left" width="160" v-model="scope.row.statusVisible"
                  popper-class="confirm-popover">
                  <p>确定{{ scope.row.status === 0 ? '停用' : '启用' }}该公司代理账号？</p>
                  <div>
                    <el-button size="small" type="default" plain @click="scope.row.statusVisible = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="statusLoading"
                      @click="handleSwitch(scope)">确定</el-button>
                  </div>
                  <div slot="reference" class="switch-wrapper" @click="handleSwitchClick">
                    <el-switch :value="scope.row.status" :inactive-value="CLOSE" :active-value="OPEN"
                      active-color="#43B034" inactive-color="#D4D4DC" />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="handleEdit(scope)">编辑</el-button>

                <el-button size="small" type="text" @click="pageNavigateToDetail(scope.row)">详情</el-button>

                <el-popover placement="left" width="160" v-model="scope.row.deleteVisible"
                  popper-class="confirm-popover">
                  <p>确定删除？</p>
                  <div>
                    <el-button size="small" type="default" plain @click="scope.row.deleteVisible = false">取消</el-button>
                    <el-button size="small" type="primary" @click="handleDelete(scope)">确定</el-button>
                  </div>

                  <span class="text lh48 ml20" slot="reference"><el-button size="small" type="text"
                      :loading="deleteLoading">删除</el-button></span>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>

          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>
        <!-- </div> -->

      </section>
</template>

<script>
import { COMMON, agentCompanyList, agentCompanyOpStatus, agentGoodsLevelList, agentServiceLevelList, agentCompanyDelete } from '../../../common/api';

export default {
  data() {
    return {
      COMMON,
      filterForm: {
        id: '',
        name: '', // 员工名字
        status: '', // 状态
        serviceLevelId: null,
        productLevelId: null
      },
      tableLoading: false,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },

      goodsLevelLoading: false,
      goodsLevelOptions: [],

      serviceLevelLoading: false,
      serviceLevelOptions: [],

      OPEN: 0, // 启用
      CLOSE: 1, // 关闭

      statusLoading: false,

      deleteLoading: false,

      tableHeight: 400
    }
  },
  mounted() {
    this.getList();
    this.getGoodsLevelList()
    this.getServiceLevelList()
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    /**
     * [getGoodsLevelList description] 获取商品分佣等级列表
     * @return {[type]} [description]
     */
    getGoodsLevelList: function () {
      this.goodsLevelLoading = true;

      let params = {
        type: 0
      }

      agentGoodsLevelList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.goodsLevelLoading = false;

          this.goodsLevelOptions = data || []
          this.goodsLevelOptions.unshift({
            id: null,
            name: '全部'
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getServiceLevelList description] 获取服务分佣等级列表
     * @return {[type]} [description]
     */
    getServiceLevelList: function () {
      this.serviceLevelLoading = true;

      let params = {
        type: 0
      }

      agentServiceLevelList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.serviceLevelLoading = false;

          this.serviceLevelOptions = data || []
          this.serviceLevelOptions.unshift({
            id: null,
            name: '全部'
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getList description] 获取列表
     * @return {[type]}          [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        'type': 0,
        'id': this.filterForm.id,
        'name': this.filterForm.name,
        'status': this.filterForm.status,
        'serviceLevelId': this.filterForm.serviceLevelId,
        'productLevelId': this.filterForm.productLevelId,
        'pageNo': this.page.current,
        'pageSize': this.page.size
      }

      agentCompanyList(param).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleAdd description] 新增
     * @return {[type]}     [description]
     */
    handleAdd: function () {
      this.$router.push('/agent/company/add');
    },
    /**
     * [handleEdit description] 编辑
     * @param  {[Object]} scope [description] 当前操作列的对象
     * @return {[type]}     [description]
     */
    handleEdit: function (scope) {
      this.$router.push({ path: '/agent/company/add', query: { id: scope.row.id, row: scope.row } });
    },
    /**
     * [pageNavigateToDetail description] 查看详情
     * @return {[type]}          [description]
     */
    pageNavigateToDetail: function (row) {
      this.$router.push({ path: '/agent/company/detail', query: { id: row.id } });
    },
    /**
     * [pageNavigateToGoodsLevel description] 商品分佣设置
     * @return {[type]}          [description]
     */
    pageNavigateToGoodsLevel: function (row) {
      this.$router.push({ path: '/agent/company/goodsLevel' });
    },
    /**
     * [pageNavigateToServiceLevel description] 服务分佣设置
     * @return {[type]}          [description]
     */
    pageNavigateToServiceLevel: function (row) {
      this.$router.push({ path: '/agent/company/serviceLevel' });
    },
    /**
     * [handleSwitch description] 启用和禁用
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleSwitch: function (scope) {
      let param = {
        'companyId': scope.row.id,
        'status': scope.row.status === 1 ? 0 : 1
      }

      this.updateStatus(param);
    },
    updateStatus: function (param) {
      this.statusLoading = true
      agentCompanyOpStatus(param).then(res => {
        let { code, data, msg } = res;
        this.statusLoading = false
        if (code == 0) {
          this.$message.success('操作成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.statusLoading = false
        this.$message.error('服务器异常');
      });
    },
    handleSwitchClick(e) {
      e.stopPropagation();
    },
    /**
     * [handleDelete description] 删除角色
     * @param  {[Object]} scope [description] 操作行的对象
     * @return {[type]}     [description]
     */
    handleDelete: function (scope) {
      this.deleteLoading = true;

      agentCompanyDelete({ 'id': scope.row.id }).then(res => {
        this.deleteLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message.success('删除成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.deleteLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    calcTableHeight() {
      // 废除表格强制高计算
      // const tableRegion = document.querySelector('.table-region')
      // const tableFooter = document.querySelector('.table-footer')
      // if (tableRegion) {
      //   const regionHeight = tableRegion.clientHeight
      //   const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
      //   this.tableHeight = regionHeight - footerHeight - 20 // 20px 为边距
      //   this.$nextTick(() => {
      //     this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }
  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}
</style>
